import { Component, Input, OnInit } from '@angular/core';
import { FileNamePipe } from 'src/app/file-name.pipe';
import { ApiService } from 'src/app/service/api.service';
import { CoreService } from 'src/app/service/core.service';

@Component({
  selector: 'app-packing-list-temp1',
  templateUrl: './packing-list-temp1.component.html',
  styleUrls: ['./packing-list-temp1.component.css']
})
export class PackingListTemp1Component implements OnInit {

@Input()print_header_footer_display;
@Input()hide_prnt_preview_h_f_show
@Input()saleQtnData;
  @Input()print_style;
  @Input()qr_inv;
  @Input()savedTemplate;
  @Input()is_prew_description;
  @Input()payTypes;
  @Input()previewLoader;
  @Input()logoImgUrl;
  @Input()tempImgUrl;
  @Input()footImgUrl;
  @Input()sales_print_name;
  @Input()hide_item_discount;
  @Input()hide_vat;
  @Input()sales_settings;
  @Input()hide_prnt_alias;
  country_dec: any;
  cmpny: any;
  noPage = [];
  noRowPerPage = 18;
  ttlPage = 1;
  data = [];
  emptyRow: any = 0;
  hide_print_header_footer: any;
  hide_print_header_footer_value = [
    { label: 'Show', value: true },
    { label: 'Hide', value: false }
  ];
  water_mark: any;

  
  constructor(private coreService: CoreService,private apiService: ApiService,private fileNamePipe: FileNamePipe) { }

  ngOnInit() {

    this.cmpny = this.coreService.getUserData('cmpny');
    this.hide_print_header_footer= this.hide_prnt_preview_h_f_show  == 1 ? true : false;
this.getTemplete();
    
      
  }

    getTemplete() {

    this.apiService.getSettings().subscribe((res) => {

      if(res.data.water_mark_img_path){
        this.water_mark = this.apiService.S3_SERVER + '/uploads/print/' + this.fileNamePipe.transform(res.data.water_mark_img_path);
      } else {
        this.water_mark = "";
      }

    });
  }

  ngOnChanges(changes) {
    if (changes['saleQtnData'] && this.saleQtnData) {
      this.data = this.saleQtnData.delivery_challan_sub;
      this.ttlPage = Math.ceil((this.saleQtnData.delivery_challan_sub.length) /this.noRowPerPage);
      this.noPage = this.createRange(this.ttlPage);
      
      this.emptyRow = this.ttlPage * this.noRowPerPage - this.saleQtnData.delivery_challan_sub.length - 1;
    }
    this.hide_print_header_footer= this.hide_prnt_preview_h_f_show  == 1 ? true : false;
  }

  createRange(number,start=0){
    let noPage = [];
    for(var i = start; i < number; i++){
       noPage.push(i);
    }
    return noPage;
  }

}
